/* eslint-disable import/prefer-default-export -- single CMS localStorage key constant */
export const CMS_BANNERS_STORAGE_KEY = "cmsBanners";
